"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collapseMenus = collapseMenus;
exports.onLoad = onLoad;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
/* istanbul ignore file */
// to handle collapse behavior on navigation for api-docs
function collapseMenus(event) {
  const currentClickedItm = event.target;
  //immedaite parent
  const immediateParent = currentClickedItm.parentElement;
  // const immediateParentClass = immediateParent.classList.value;
  const currentClickedParentLi = immediateParent.closest('li.sidebar-nav-item');
  const currentClicked1stSpecChild = currentClickedParentLi.querySelector('.api-contract'); //get first contract if any
  const currentClickedfirstDoc = currentClickedParentLi.querySelector('a.sidebar-title'); //get first doc if any
  const isMainParent = immediateParent.classList.contains('level-1-item'); //Main parent menu item, eg: Commericail banking Apis
  const isSecondLevelParent = immediateParent.classList.contains('level-2-item'); //API parent menu item , eg: ACH Transfers
  const isThirdLevelParent = immediateParent.classList.contains('level-3-item'); //API Contract Parent, eg: Domestic ACH
  if (isMainParent) {
    //handle only main parent dropdown click ie, commercial Banking Apis menu item
    //close/open main parent dropdown
    currentClickedItm.closest('li.sidebar-nav-item').classList.toggle('open');
  } else {
    //not the main parent and handle other parent dropdown clicks
    if (isSecondLevelParent) {
      //second level parent dropdown clicks m ie: API parent menu item dropdown
      //get all level 2 li elements and convert them in to array lists of nodes
      //filter current dropdown item out of the array lists of nodes
      const all2ndlvlChildLis = immediateParent.closest('li.level-1-item').querySelectorAll('li.level-2-item');
      const otherChildLis = Array.from(all2ndlvlChildLis).filter(li => li !== currentClickedParentLi);
      //close all other level 2 dropdowns
      otherChildLis.forEach(itemElem => {
        itemElem.classList.remove('open');
      });
      //close/open only current dropdown
      currentClickedParentLi.classList.toggle('open');
      //if first content to render is a business doc, navigate to the doc
      if (currentClickedfirstDoc && currentClickedParentLi.classList.contains('open')) {
        currentClickedfirstDoc.click();
      }
      //if first content to render is a contract, navigate to the contract and make it active
      if (currentClicked1stSpecChild && currentClickedParentLi.classList.contains('open')) {
        var _currentClicked1stSpe;
        currentClicked1stSpecChild === null || currentClicked1stSpecChild === void 0 || (_currentClicked1stSpe = currentClicked1stSpecChild.closest('li')) === null || _currentClicked1stSpe === void 0 || _currentClicked1stSpe.classList.add('open');
      }
    } else if (isThirdLevelParent) {
      //Third level parent dropdown clicks  ie: API contract parent menu item dropdown
      const all3rdlvlChildLis = immediateParent.closest('li.level-2-item').querySelectorAll('li.level-3-item');
      const otherChildLis = Array.from(all3rdlvlChildLis).filter(li => li !== currentClickedParentLi);
      otherChildLis.forEach(itemElem => {
        itemElem.classList.remove('open');
      });
      currentClickedParentLi.classList.toggle('open');
      if (currentClickedfirstDoc && currentClickedParentLi.classList.contains('open')) {
        currentClickedfirstDoc.click();
      }
      if (currentClicked1stSpecChild && currentClickedParentLi.classList.contains('open')) {
        var _currentClicked1stSpe2;
        currentClicked1stSpecChild === null || currentClicked1stSpecChild === void 0 || (_currentClicked1stSpe2 = currentClicked1stSpecChild.closest('li')) === null || _currentClicked1stSpe2 === void 0 || _currentClicked1stSpe2.classList.add('open');
      }
    } else {
      // const isMainParentNonDropdownItem = ['level--1', 'level--2', 'level--3', 'level--4'].some(
      //   (cls) => currentClickedParentLi.parentElement.classList.contains(cls),
      // );

      // if (!isMainParentNonDropdownItem && currentClickedParentLi.parentElement.tagName) {
      //   document
      //     .querySelectorAll('li.level-2-item.open')
      //     .forEach((elem) => elem.classList.remove('open'));
      // }

      return;
    }
  }
  event.stopPropagation();
}

// To open the first spec collection onload
function onLoad() {
  const liElement = document.querySelector('li.sidebar-nav-item--active');
  const parentUL = liElement === null || liElement === void 0 ? void 0 : liElement.closest('ul.sidebar-nav-items.level--2');
  if (liElement == (parentUL === null || parentUL === void 0 ? void 0 : parentUL.firstChild)) {
    const firstSpecChild = parentUL === null || parentUL === void 0 ? void 0 : parentUL.querySelector('.api-contract');
    // open first spec child
    if (firstSpecChild) {
      var _firstSpecChild$close;
      firstSpecChild === null || firstSpecChild === void 0 || (_firstSpecChild$close = firstSpecChild.closest('li')) === null || _firstSpecChild$close === void 0 || _firstSpecChild$close.classList.add('open');
    }
  }
}